// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_3p-0";